import { PickersDay } from '@mui/lab'
import { styled } from '@mui/material/styles'
import { theme } from 'modules/App/Providers/Theme/theme'

interface CustomPickersDayProps {
  dayState: 'PARTIAL' | 'AVAILABLE' | 'NOT_AVAILABLE' | 'DISABLED'
}

const shouldForwardProp = (propName: string) => !['dayState'].includes(propName)

/**
 * https://mui.com/components/date-picker/#customized-day-rendering
 */
const CustomPickersDay = styled(PickersDay, { shouldForwardProp })(({ dayState }: CustomPickersDayProps) => {
  if (dayState === 'PARTIAL') return { color: theme.palette.warning.main }

  if (dayState === 'DISABLED') {
    return {
      '&.Mui-disabled': {
        cursor: 'not-allowed',
        pointerEvents: 'unset',
      },
    }
  }

  if (dayState === 'NOT_AVAILABLE') {
    return {
      color: theme.palette.error.main,
      textDecoration: 'line-through',
      '&:hover': {
        background: `${theme.palette.primary.light}77 !important`,
        color: theme.palette.error.main,
        textDecoration: 'line-through',
      },
      '&:focus': {
        background: `${theme.palette.primary.main} !important`,
        color: theme.palette.common.white,
        textDecoration: 'line-through',
      },
    }
  }

  return {}
})

export { CustomPickersDay }
